import React from 'react';
import { useNavigate } from 'react-router-dom';

import { TJobRenderComponentProps } from '@/console/features/jobs/components/jobs-list/jobs-list-renderer.types';
import { useFeature } from '@/console/features/pipelines/hooks/use-feature/use-feature';
import { TextButton } from '@/shared/components/ui/button/text-button/text-button';
import { useReadProjectsByIdsQuery } from '@/shared/redux/api/assets/projects/projects-api';
import { formatVersionId } from '@/shared/utils/format';

export const JobProjectVersion: React.FC<TJobRenderComponentProps> = ({
  job,
  versionIndex = 0,
}) => {
  const navigate = useNavigate();
  const { isDeviceFeature } = useFeature();
  const { data: projectsData } = useReadProjectsByIdsQuery(
    { projectIds: job?.projectIds! },
    { skip: !job?.projectIds?.length || isDeviceFeature([job?.jobType]) },
  );

  const project = projectsData?.readProjectsByIds?.items?.[0];
  const versionId = job?.projectVersionIds?.[versionIndex];

  if (!versionId || (job && isDeviceFeature([job?.jobType]))) {
    return null;
  }

  return (
    <TextButton
      variant="primaryLighter"
      onClick={(e) => {
        e.stopPropagation();
        navigate(`/projects/${project?.projectId}/versions`);
      }}
      tooltip={versionId}
      disabled={!project}
    >
      {formatVersionId({ versionId })}
    </TextButton>
  );
};
